






























































import { Component, Mixins, Watch } from "vue-property-decorator";
import BaseServiceMixin from "../mixins/base.service.mixin";
import DepartmentModel from "../models/DepartmentModel";
import DepartmentService from "../services/department.service";
import eventBus from "../common/bus";
import UpsertDepartment from "@/components/UpsertDepartment.vue";
import { Role } from "@/common/enum";
import Shared from "../common/shared";

@Component({
  components: {
    UpsertDepartment,
  },
})
export default class Home extends Mixins(BaseServiceMixin) {
  private departments: DepartmentModel[] = [];
  private departmentService!: DepartmentService;
  private department: DepartmentModel = new DepartmentModel();
  private isModelActive = false;
  private role = Role;

  public created() {
    this.departmentService = new DepartmentService(this.axiosInstance);
  }

  private async mounted() {
    await this.getDepartments();
  }

  @Watch("isModelActive")
  private onModelActivity() {
    if (!this.isModelActive) {
      this.department = new DepartmentModel();
    }
  }

  private async getDepartments() {
    eventBus.$emit("loading", true);
    try {
      const departments: DepartmentModel[] = await this.departmentService.getDepartments();
      this.departments = departments;
    } catch (error) {
      // Handle error
    } finally {
      eventBus.$emit("loading", false);
    }
  }

  private editDepartment(department: DepartmentModel) {
    this.department = department;
    this.isModelActive = true;
  }

  private async onSaveDepartment() {
    this.isModelActive = false;
    await this.getDepartments();
  }

  private async confirmDeleteDepartment(id: number) {
    this.$buefy.dialog.confirm({
      title: "Delete Department",
      message: "Are you sure you want to <b>delete</b> this department? This action cannot be undone.",
      confirmText: "Delete",
      type: "is-danger",
      hasIcon: true,
      onConfirm: () => this.deleteDepartment(id),
    });
  }

  private async deleteDepartment(id: number) {
    eventBus.$emit("loading", true);
    try {
      await this.departmentService.deleteDepartment(id);
      await this.getDepartments();
    } catch (error) {
      if (error.name === Shared.conflict) {
        Shared.showToastMessage(error.message || Shared.messages.DEPARTMENT_DELETE_CONFLICT, "is-danger");
      }
    } finally {
      eventBus.$emit("loading", false);
    }
  }
}
